/** Pure closing rules: counts, the blocking control and the reopen gate (spec §5). */

import type { Language } from '../../i18n/catalogs';
import type {
  ClosingSummary,
  ControlOutcome,
  I18nText,
} from './closing.api';

export type ReopenRefusal = 'closing.adminOnly' | 'closing.reasonRequired';

export function summariseControls(controls: readonly ControlOutcome[]): ClosingSummary {
  const passed = controls.filter((control) => control.status === 'passed').length;
  const failed = controls.filter((control) => control.status === 'failed').length;
  const skipped = controls.filter((control) => control.status === 'skipped').length;
  return {
    total: controls.length,
    passed,
    failed,
    skipped,
    blockingFailed: blockingControls(controls).length,
  };
}

/** A failed `warning` is listed but does not stop the close; every other severity does. */
export function blockingControls(controls: readonly ControlOutcome[]): ControlOutcome[] {
  return controls.filter((control) => control.status === 'failed' && control.severity !== 'warning');
}

export function closeBlockedBy(controls: readonly ControlOutcome[]): ControlOutcome | undefined {
  return blockingControls(controls)[0];
}

/** Only an admin reopens a closed period, and only with a written reason. */
export function reopenRefusal(roles: readonly string[], reason: string): ReopenRefusal | null {
  if (!roles.includes('admin')) {
    return 'closing.adminOnly';
  }
  if (reason.trim() === '') {
    return 'closing.reasonRequired';
  }
  return null;
}

export function controlTitle(title: I18nText, language: Language): string {
  if (language === 'en') {
    return title.en;
  }
  if (language === 'ru') {
    return title.ru;
  }
  return title.az;
}
